import axios from '@/axios';

// URL and endpoint constants
const INDEX_URL = '/technical_supports/1';
const QUESTION_URL = '/question_technical_supports';

export default {
  index(succ) {
    axios.get(INDEX_URL)
      .then((response) => { succ(response); });
  },
  question(succ) {
    axios.get(QUESTION_URL)
      .then((response) => { succ(response); });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/technicalSupport.js